import { render, staticRenderFns } from "./PlayerBottomBar.vue?vue&type=template&id=f33ca81c&"
import script from "./PlayerBottomBar.vue?vue&type=script&lang=js&"
export * from "./PlayerBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./PlayerBottomBar.vue?vue&type=style&index=0&id=f33ca81c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports